import React from 'react'
import { StyleSheet } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { StepsPaginator } from 'partials/PostStepsPaginator/StepsPaginator'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useNavigateBackOrHome } from 'hooks/useNavigateBackOrHome'

import { Post } from 'types/post'

const styles = StyleSheet.create({
  header: {
    top: 0,
    left: 0,
    width: '100%',
  },
})

export const PlayerHeader = ({
  post,
  currentStep,
  totalSteps,
  progress,
}: {
  post?: Post
  currentStep: number
  totalSteps: number
  progress: number
}) => {
  const insets = useSafeAreaInsets()
  const navigate = useNavigateBackOrHome()

  return (
    <Box
      pointerEvents='box-none'
      style={styles.header}
      margin={{ top: insets.top !== 0 ? insets.top : 'lg' }}
      position='absolute'
      testID='PlayerHeader'
    >
      <Box
        flexDirection='row'
        align='center'
        justifyContent='flex-end'
        margin={{ horizontal: 'smd' }}
      >
        <Box
          position='absolute'
          width='100%'
          flex={1}
          flexDirection='row'
          align='center'
          justifyContent='center'
          testID='PlayerHeader-StepCount'
        >
          <Text fontSize='sm' bold color='white'>
            {`${currentStep} / ${totalSteps}`}
          </Text>
        </Box>
        <Box testID='PlayerHeader-CloseButton'>
          <Pressable onPress={navigate} hitSlop={4}>
            <Icon color='white' name='x' size={32} />
          </Pressable>
        </Box>
      </Box>
      <Box height={8} justifyContent='center'>
        <StepsPaginator
          post={post}
          currentStep={currentStep}
          totalSteps={totalSteps}
          progress={progress}
        />
      </Box>
    </Box>
  )
}
